import { RootState } from '../types'

export const getMainClientSelector = (state: RootState) => state.client

export const getClientsSelector = (state: RootState) => state.client.clients
